









































































import { Vue, Component } from 'vue-property-decorator';
import { popupResize } from '@/utils/ncp';
import { PutWithdrawalMembersRequest, GetMembersMemberNo } from 'supporter';
import CompRadioButton from '@/components/common/CompRadioButton.vue';
import { namespace } from 'vuex-class';

const withdrawModule = namespace('withdrawMember');

@Component({
  components: {
    CompRadioButton,
  },
})
export default class ExpelMember extends Vue {
  @withdrawModule.Action('putWithdrawalMembers')
  private putWithdrawalMembers: (query: PutWithdrawalMembersRequest) => Promise<void>;

  private memberName: string = '';
  private memberId: string = '';
  private reason: string = '';
  private reasonDetail: string = '';

  get memberNumbers(): number[] {
    return (this.$route.query.memberNumbers as string).split(',').map(value => parseInt(value, 10));
  }

  get isMembers(): boolean {
    return this.memberNumbers.length > 1;
  }

  get totalReason(): string {
    return `${this.reason} - ${this.reasonDetail}`;
  }

  private putWithdrawalMembersRequest: PutWithdrawalMembersRequest = {
    data: {
      reason: '',
      memberNos: [],
      sendTypes: 'EMAIL',
      mallNo: -1,
    },
  };

  // 강제탈퇴 사유
  private memberExpelNoticeSendTypes = {
    name: 'skipsAccumulation',
    data: [
      {
        id: 'notificationMethod_email',
        value: 'EMAIL',
        dispaly: 'MEMBER_EXPEL_REASON_EMAIL',
      },
      {
        id: 'notificationMethod_sms',
        value: 'SMS',
        dispaly: 'MEMBER_EXPEL_REASON_SMS',
      },
      {
        id: 'notificationMethod_all',
        value: 'ALL',
        dispaly: 'MEMBER_EXPEL_REASON_SEND_ALL',
      },
    ],
  };

  private mounted(): void {
    ExpelMember.resizePopupWindow();
    this.fetchMemberData();
  }

  private static resizePopupWindow(): void {
	  document.body.classList.add('popup_small');
    popupResize();
  }

  private destroyed(): void {
    document.body.classList.remove('popup_small');
  }

  private async fetchMemberData(): Promise<void> {
    const { data }: { data: GetMembersMemberNo } = await this.$api.getMembersMemberNo({
      pathParams: {
        memberNo: this.memberNumbers[0].toString(),
      },
    });

    this.memberName = data.memberName;
    this.memberId = data.memberId;
    this.putWithdrawalMembersRequest.data.mallNo = data.mallNo;
  }
	
  private onSubmitExpel(): void {
    this.putWithdrawalMembersRequest.data.memberNos = this.memberNumbers;
    this.putWithdrawalMembersRequest.data.reason = this.totalReason;

    if (!this.validate()) return;
    if (!this.expelConfirm()) return;

    this.onPutRequest();
  }

  private validate(): boolean {
    if (!this.reason?.trim()) {
      alert(this.$t('MEMBER_EXPEL_ALERT_REASON_INPUT_EMPTY'));
      (this.$refs.expelReason as HTMLInputElement).focus();
      return false;
    }

    if (this.putWithdrawalMembersRequest.data.sendTypes !== 'SMS' && !this.reasonDetail?.trim()) {
      alert(this.$t('MEMBER_EXPEL_ALERT_NOTICE_CONTENT_EMPTY'));
      (this.$refs.reasonDetail as HTMLTextAreaElement).focus();
      return false;
    }

    return true;
  }

  private expelConfirm(): boolean {
    return confirm(this.$t('MEMBER_EXPEL_CONFIRM_TEXT').toString());
  }

  private onPutRequest(): void {
    this.putWithdrawalMembers(this.putWithdrawalMembersRequest).then(() => {
      alert(
        this.$t('MEMBER_EXPEL_SUCCESS_MESSAGE')
          .toString()
          .replace('%d', this.memberNumbers.length.toString()),
      );
      this.onCloseWindow();
    });
  }

  private onClickCancel(): void {
    this.onCloseWindow();
  }

  private onCloseWindow(): void {
    window.close();
  }
}
